/* eslint-disable */
import { Box, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useReportContext } from '../../../../base/components/reports/ReportLayout';
import { LIST_REPORTS } from '../../report-operator-profit.list';
import Empty from '../../../../base/components/empty';
import OverallTable from './OverallTable';
// import PrepaidTable from './PrepaidTable';
import StandardTable from './StandardTable';
import MarketingTable from './MarketingTable';
import { useTranslate } from 'react-admin';

const OperatorProfitReportResults = () => {
  const { data, loading: loadingAllData } = useReportContext();
  const translate = useTranslate();

  const hasNoData = useMemo(() => {
    const totalTableNoData = Object.values(data).reduce((totalNoDataTable, table) => {
      if (!table?.total && Array.isArray(table?.data)) {
        return totalNoDataTable + 1;
      }
      return totalNoDataTable;
    }, 0);
    return totalTableNoData === LIST_REPORTS.length && !loadingAllData;
  }, [data, loadingAllData]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        gap: 24,
      }}
    >
      {hasNoData ? (
        <Empty />
      ) : (
        <>
          {/* Temporarily hide */}
          {/* <OverallTable /> */}

          <Box display={'flex'} flexDirection={'column'} sx={{ gap: 8 }}>
            {(Array.isArray(data?.overall?.data) || Array.isArray(data?.standard?.data) || loadingAllData) && (
              <Typography variant="h4">{translate('resources.report.standard')}</Typography>
            )}
            <OverallTable />
            <StandardTable />
          </Box>
          <MarketingTable />
          {/* <PrepaidTable /> */}
        </>
      )}
    </Box>
  );
};

export default OperatorProfitReportResults;
